// extracted by mini-css-extract-plugin
export default {"container":"k2hH0E","timer":"stWkj8"};